import React from 'react';
import {
  IconEbike,
  IconCar,
  IconBike,
  IconMoped,
} from '@justeattakeaway/pie-icons-react';
import { globalStyles } from 'snacks-design-system';
import { CourierVehicleType } from '@src/pages/Deliveries/context/couriers';
import { VehicleType } from '@src/graphql_types';
interface IDashboardVehicleSelectorProps {
  vehicleType: CourierVehicleType;
  iconColor?: string;
  iconSize?: 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';
}
export const DashboardVehicleSelector = ({
  vehicleType,
  iconColor = globalStyles.xdsColorContentLight,
  iconSize = 'm',
}: IDashboardVehicleSelectorProps) => {
  const icons = {
    [VehicleType.Bike]: <IconBike color={iconColor} size={iconSize} />,
    [VehicleType.Car]: <IconCar color={iconColor} size={iconSize} />,
    [VehicleType.Scooter]: <IconMoped color={iconColor} size={iconSize} />,
    [VehicleType.Ebike]: <IconEbike color={iconColor} size={iconSize} />,
    [VehicleType.Unknown]: <IconBike color={iconColor} size={iconSize} />,
  };
  return vehicleType ? icons[vehicleType] : icons[VehicleType.Bike];
};

export default DashboardVehicleSelector;
